import {Component, inject, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {AppInputComponent} from '@shared/components/forms/app-input/app-input.component';
import {AlertService} from '@core/services/alert.service';
import {ReactiveFormAbstract} from '@shared/commons/reactive-form-abstract.utils';
import {AuthService} from "@core/services/auth.service";
import {StorageService} from "@core/services/storage.service";

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        AppInputComponent
    ],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent extends ReactiveFormAbstract implements OnInit {
    showPassword = signal<boolean>(false);
    rememberMe = signal<boolean>(false);

    private router = inject(Router);
    private storageService = inject(StorageService);
    private authService = inject(AuthService);
    private alertService = inject(AlertService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.form = this.createForm();
        this.loadRememberedEmail();
    }

    protected createForm(): FormGroup {
        return this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]]
        });
    }

    private loadRememberedEmail(): void {
        const rememberedEmail = this.storageService.rememberEmail;
        if (rememberedEmail) {
            this.setValue('email', rememberedEmail);
            this.rememberMe.set(true);
        }
    }

    togglePasswordVisibility(): void {
        this.showPassword.set(!this.showPassword());
    }

    toggleRememberMe(): void {
        this.rememberMe.set(!this.rememberMe());
    }

    protected async submit() {
        this.loading = true;

        this.authService.login(this.getValue('email'), this.getValue('password'))
            .subscribe({
                next: (response) => {
                    if (this.rememberMe()) {
                        this.storageService.rememberEmail = response.data.user.email;
                    } else {
                        this.storageService.rememberEmail = '';
                    }
                    this.loading = false;
                    this.router.navigate(['/dashboard']);
                },
                error: (_error) => {
                    this.loading = false;
                    if(_error?.error?.code === 'INVALID_CREDENTIALS'){
                        this.alertService.error('Ops', 'Verifique seu e-mail e senha e tente novamente.');
                        return;
                    }

                    if(_error?.error?.code === 'USER_INACTIVE'){
                        this.alertService.error('Ops', 'Sua conta está inativa. Por favor, entre em contato com o suporte.');
                        return;
                    }

                    this.alertService.operationFailure();
                }
            });
    }

    navigateToForgotPassword(): void {
        this.alertService.info('LOGIN.FORGOT_PASSWORD', 'LOGIN.FORGOT_PASSWORD_INFO');
    }
}

